module.exports = __webpack_public_path__ + "img/thunderbird.cff962f9.webp";